import React from "react";
import PropTypes from "prop-types";
import { Link as GatsbyLink } from "gatsby";
import { useTranslation } from "react-i18next";

const Link = ({ to, children, ...rest }) => {
  const { i18n } = useTranslation();
  const { language, options: { fallbackLng: [fallbackLng] = [] } = {} } = i18n;
  const path = language ? language !== fallbackLng ? `/${language}${to}` : to : to;

  return (
    <GatsbyLink to={path} {...rest}>
      {children}
    </GatsbyLink>
  );
};

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Link;
